import { Suspense, lazy } from "react";
import Label from "../_components/typography/label.typography";
const LottiePlayer = lazy(() => import("../_components/molecule/lottie-player"));

/**
 * 404 Not Found Page
 */

const NotFoundPage = () => {
  return (
    <div className="flex flex-col gap-4 items-center">
     <Suspense fallback={<></>}>
      <LottiePlayer
          src={"https://assets4.lottiefiles.com/private_files/lf30_k6fpeaa5.json"}
          controlVisible={false}
          loop={true}
          className="w-1/2"
        />
     </Suspense>
      <Label size="h1" variant="s2">
        404 Not Found
      </Label>
    </div>
  );
};

export default NotFoundPage;
